import { ReactElement } from 'react';

import { UploadResult } from 'firebase/storage';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import Team from '../../types/Team';
import GratiColorPicker from '../common/GratiColorPicker';
import GratiImageUpload from '../common/GratiImageUpload';

export interface TeamGeneralSettingsEditorProps {
  team: Team;
  isNew?: boolean;
  onUpdate: <K extends keyof Team>(field: K, value: Team[K]) => void;
  onImageUpdated?: (snapshot: UploadResult | null) => void;
  onFileSelected?: (file: File | null) => void;
}

export default function TeamGeneralSettingsEditor(props: TeamGeneralSettingsEditorProps): ReactElement {
  const { team, isNew, onUpdate, onImageUpdated, onFileSelected } = props;

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} sx={{
        alignItems: "center"
      }}>
        <TextField
          id="name"
          label="Team Name"
          aria-label="Team Name"
          aria-required="true"
          required
          autoComplete="off"
          slotProps={{ htmlInput: { 'data-1p-ignore': true } }}
          value={team.name}
          onChange={({ target }) => onUpdate('name', target.value)}
          sx={{ flexGrow: 1, maxWidth: 'sm' }}
        />
        <GratiImageUpload
          onImageUpdated={isNew ? undefined : onImageUpdated}
          onFileSelected={isNew ? onFileSelected : undefined}
          deferUpload={isNew}
          isInitialized={!isNew && Boolean(team.logo)}
          storageImageFileName={team.itemId + '-logo'}
          storageImageLocation={`org/${team.orgId}/league/${team.leagueId}/team/${team.itemId}/orgMemberTeamManagerFile`}
          label="Logo"
          isCompact
          size="large"
        />
      </Stack>
      <Stack direction="row" spacing={2} sx={{
        alignItems: "center"
      }}>
        <TextField
          id="description"
          label="Description"
          aria-label="Description"
          aria-required="false"
          multiline
          minRows={2}
          value={team.description}
          onChange={({ target }) => onUpdate('description', target.value)}
          sx={{ flexGrow: 1, maxWidth: 'sm' }}
        />
        <GratiColorPicker
          value={team.color}
          onChange={(color) => onUpdate('color', color)}
        />
      </Stack>
    </Stack>
  );
}
